var userInfo = localStorage.getItem("userInfo")
userInfo  = JSON.parse(userInfo);
const userDefaults = userInfo ? userInfo : {}

// eslint-disable-next-line
var state = {
  loggedInUser: userDefaults,
  userRole: "admin"
}

// eslint-disable-next-line
export const login = (state = {
  loggedInUser: userDefaults,
  userRole: "admin"
}, action) => {
  switch (action.type) {
    case "CHANGE_ROLE": {
      return { ...state, userRole: action.userRole }
    }
    case "UPDATE_USER_INFO_KEY": {
      let userInfo = JSON.parse(localStorage.getItem("userInfo")) || state.loggedInUser
      for (const property of Object.keys(action.data)) {
        if (action.data[property] != null) {
          state.loggedInUser[property] = action.data[property]
          userInfo[property] = action.data[property]
        }
      }
      localStorage.setItem("userInfo", JSON.stringify(userInfo))
      return state.loggedInUser;
    }
    case "UPDATE_USER_INFO": {
      console.log('aa', action)
      localStorage.setItem("userInfo", JSON.stringify(action.data))
      return { ...state, loggedInUser: action.data };
    }
    case "GET_CURRENT_USER": {
      var userInfo = localStorage.getItem("userInfo")
      userInfo  = JSON.parse(userInfo);
      const userDefaults = userInfo ? userInfo : {}
      return { ...state, loggedInUser: userInfo };
    }
    default: {
      return state
    }
  }
}
